import * as React from "react"

const MOBILE_BREAKPOINT = 768
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(QUERY)
  mql.addEventListener("change", onChange)
  return () => mql.removeEventListener("change", onChange)
}

const getSnapshot = () => window.innerWidth < MOBILE_BREAKPOINT
// The server has no width: it, and hydration, draw desktop as before.
const getServerSnapshot = () => false

/**
 * True below 768px. Read straight from the window on the first render, so
 * something mounted after hydration (a window opening on a phone) draws its
 * phone layout at once. Read in an effect, it drew the desktop layout for a
 * frame first, and a window that swapped for another jumped on a phone.
 */
export function useIsMobile() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
